import React from 'react';
import type { MultiKey } from '../core/MultiKey';
import type { LocationId } from '@seaber/common/core/entries';

export type PortCostPair = [locationId: LocationId, assortmentId: number];

export type MarcuraPortCostParams = [
  locationId: LocationId,
  assortmentId: number,
];

export type PortCostData = {
  id: number;
  marcura_port_id: string;
  marcura_group_id: string;
  location_id: LocationId;
  assortment_id: number;
  cached_at: string;
  data: {
    costs: Array<{
      dwtMax: number;
      dwtMin: number;
      segmentName?: string | null;
      costLoading?: number | null;
      costDischarging?: number | null;
    }>;
  };
};

export type MarcuraPortCosts = {
  get: (...pair: PortCostPair) => PortCostData | undefined;
  set: (data: PortCostData) => void;
  map: MultiKey<PortCostData, MarcuraPortCostParams>;
};

export interface MarcuraPortCostContextProps {
  portCosts: MarcuraPortCosts;
  queuePortCostsForPairs: (pairs: PortCostPair[]) => void;
  fetchMissingMarcuraPortCosts: (
    existingPortCosts: MarcuraPortCosts,
    portIds: Set<LocationId>,
    assortmentIds: Set<number>,
  ) => Promise<MarcuraPortCosts>;
  resetPortCosts: () => void;
}

export const MarcuraPortCostContext = React.createContext<
  MarcuraPortCostContextProps | undefined
>(undefined);
